<template>
	<Col class="width-100 height-100 page-wrapper">
		<Col class="width-100 height-100 flex-align-center overflow-y-auto">
			<Col class="content-container height-100">
				<h1 class="reg mt-3">Welcome to Ply 👋</h1>
				<Row class="flex-justify-space-between my-3">
					<Row class="onboarding-title">What are we building today?</Row>
					<Row class="flex-align-center">
						<AnemicButton v-if="canCreateNew" @click="showWizard" class="new-button">New Feature</AnemicButton>
					</Row>
				</Row>
				<h2 class="reg feature-type-text">Choose a feature type to see onboarding</h2>
				<router-link
					:key="featureType.id"
					:to="getRouteTo(featureType)"
					class="mt-3 width-100 text-decoration-none"
					v-for="featureType in useGettingStartedSettings"
				>
					<Col class="feature-type-container flex-justify-center width-100 mt-2 pl-5 pr-7">
						<Row class="flex-align-center width-100 flex-justify-space-between">
							<Row class="flex-align-center">
								<AppIcon :name="featureType.iconName" class="mr-3" />
								<Col>
									<div class="feature-type-title">{{ featureType.title }}</div>
									<div class="feature-type-description">{{ featureType.description }}</div>
								</Col>
							</Row>
							<AppIcon name="getting-started-right-arrow" class="right-arrow" />
						</Row>
					</Col>
				</router-link>
			</Col>
		</Col>
	</Col>
</template>

<script>
import { mapGetters } from 'vuex';
import { setDidSeeUtmIntro } from '@/store/modules/appLayout/actions';
import { useDidSeeUtmIntro } from '@/store/modules/appLayout/getters';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { useGettingStartedSettings } from '@/store/modules/featureFlags/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'GettingStartedIntro',
	props: {},
	components: {},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ hasAccountPermission, useGettingStartedSettings, useDidSeeUtmIntro }),
		canCreateNew() {
			return this.hasAccountPermission(AccountPermissions.CreateWorkflows);
		},
	},
	methods: {
		...mapActionsShorthand({ setDidSeeUtmIntro }),
		showWizard() {
			AppDialogManagerService.openCreationWizardDialog({ initialState: { projectId: null } });
		},
		getRouteTo(featureType) {
			if (featureType.overrideRouteTo) {
				return { name: featureType.overrideRouteTo };
			}
			return { name: 'GettingStartedLandingPage', params: { featureType: featureType.id } };
		},
	},
	async mounted() {
		if (!this.useDidSeeUtmIntro) {
			const userUtmTerm = this.user?.profile?.metadata?.utms?.utm_term;
			if (userUtmTerm) {
				this.setDidSeeUtmIntro({ didSeeUtmIntro: true });
				return this.$router.push({ name: 'GettingStartedLandingPage', params: { featureType: userUtmTerm } });
			}
		}
	},
};
</script>

<style scoped lang="scss">
.page-wrapper {
	background: #f9fafc;
}
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.onboarding-title {
	font-size: 30px;
	font-weight: bold;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
.content-container {
	opacity: 1;
	height: 100%;
	margin: 70px 0 70px 0;
	max-width: 1120px;
	width: calc(100% - 40px);
}
.embedded-iframe-container {
	border-radius: 15px;
	box-shadow: 0px 2px 10px 2px #00000012;
}
.feature-type-text {
	color: #646e87;
}
.feature-type-container {
	height: 162px;
	transition: 0.3s;
	background: #ffffff;
	&:hover {
		transition: 0.3s;
		border: 1px solid #5b5be7;
		box-shadow: 0px 2px 10px 2px #00000012;
	}

	border-radius: 15px;
	letter-spacing: 0px;
	background: var(--white);
	transition: 0.3s;
	color: var(--primary-font-color);
	border: 1px solid var(--border-color);
	&:hover {
		cursor: pointer;
		transition: 0.3s;
		border: 1px solid #5b5be7;
		box-shadow: 0px 2px 10px 2px #00000012;
		::v-deep {
			.right-arrow {
				path {
					fill: #5b5be7;
				}
			}
		}
	}
	&:active {
		transition: 0.3s;
		filter: brightness(0.9);
	}
}
.feature-type-title {
	font-size: 24px;
	font-weight: 600;
}
.feature-type-description {
	font-size: 16px;
	font-weight: 400;
}
</style>
